import React from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from '../../../../../../../../../../common/react/components/SvgIcon';
import { getTranslation } from '../../../../../../../../../../common/react/utils/translations';

const CLASS_BLOCK = 'player-stats-tooltip-link';

/**
 * @param {object} props - Props.
 * @param {object} props.player - Player.
 * @returns {JSX.Element} Component.
 */
export const PlayerStatsTooltipLink = ({ player }) => {
    const playerProfileURL = PULSE.app.common.url.getPlayerProfileURL(
        player.details.playerId
    );

    return (
        <a href={playerProfileURL} className={CLASS_BLOCK}>
            <SvgIcon className={`${CLASS_BLOCK}__icon`} icon={`person`} />
            <span>{getTranslation('label.bio.fullProfile')}</span>
        </a>
    );
};

PlayerStatsTooltipLink.propTypes = {
    player: PropTypes.object.isRequired
};
